import React from 'react';
import { SearchForm } from '../../../components/organism/SearchForm/SearchForm';
import useSearchLink from "../../../features/searchLink/application/useSearchLink";
import { GeneralLayout } from '../../../components/layout/GeneralLayout/GeneralLayout';

export const SearchLinkPage: React.FC = () => {
  const { setFormData, handleSubmit, data } = useSearchLink();
  // Un manejador de cambios genérico para simplificar los inputs
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({
      ...data.formData,
      [name]: value,
    });
  };

  return (
    <GeneralLayout>
      <div className="card">
        <h1 className="text-2xl font-bold mb-7 mt-7 text-center">Recuperar mi enlace de referido</h1>
        <p className="text-gray-500 mb-6 text-center">
          Ingresa tu número de celular para encontrar tu enlace.
        </p>
        <SearchForm
          textButton="Buscar enlace"
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          data={data}
        />
      </div>
    </GeneralLayout>
  );
};
